import {Component, Input, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.css']
})
export class CustomTooltipComponent {

  @Input() tooltipTemplate: TemplateRef<any>;

  constructor() { }
}
